import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user_code : "",
    user_name : "",
    editer : "",
    date_s : "",
    branch : "",
    docno : "",
    date_branch_order : "" ,
    branch_selected : "" ,
    point : 0 ,
    branch_code : "" ,
  },
  mutations: {
    set_user_code (state, active_user) {
      state.user_code = active_user
    },
    set_date_branch_order (state, date_branch_order) {
      state.date_branch_order = date_branch_order
    },
    set_branch_selected (state, branch_selected) {
      state.branch_selected = branch_selected
    },
    set_user_name (state, active_user) {
      state.user_name = active_user
    },
    set_editer (state, active_user) {
      state.editer = active_user
    },
    set_point (state, point) {
      state.point = point
    },
    set_date (state, date_s) {
      state.date_s = date_s
    },
    set_branch (state, branch) {
      state.branch = branch
    },
    set_docno (state, docno ) {
      state.docno = docno
    },
    set_branch_code (state, branch_code ) {
      state.branch_code = branch_code
    },
  },
  actions: {
    set_user_ac_code ( context , active_user ) {
      context.commit('set_user_code', active_user )
    },
    set_date_branch_order_ac ( context , date_branch_order ) {
      context.commit('set_date_branch_order', date_branch_order )
    },
    set_branch_selected_ac ( context , branch_selected ) {
      context.commit('set_branch_selected', branch_selected )
    },
    set_user_ac_name ( context , active_user ) {
      context.commit('set_user_name', active_user )
    },
    set_user_ac_editer ( context , edit_mode ) {
      context.commit('set_editer', edit_mode )
    },
    set_point_ac ( context , point ) {
      context.commit('set_point', point )
    },
    set_date_ac ( context , date_s ) {
      context.commit('set_date', date_s )
    },
    set_branch_ac ( context , branch ) {
      context.commit('set_branch', branch )
    },
    set_docno_ac ( context , docno ) {
      context.commit('set_docno', docno )
    },
    set_branch_code_ac ( context , branch_code ) {
      context.commit('set_branch_code', branch_code )
    },
  },
  modules: {
  },
  getters:{
    get_user_code (state) {
      return state.user_code
    },
    get_date_branch_order(state) {
      return state.date_branch_order
    },
    get_branch_selected(state) {
      return state.branch_selected
    },
    get_user_name (state) {
      return state.user_name
    },
    get_edit_mode (state) {
      return state.editer
    },
    get_point (state) {
      return state.point
    },
    get_date (state) {
      return state.date_s
    },
    get_branch (state) {
      return state.branch
    },
    get_docno (state) {
      return state.docno
    },
    get_branch_code(state) {
      return state.branch_code
    },
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js